<template>
  <div class="price-filter">
    <form class="form">
      <label
        v-for="(priceRange, index) in priceRanges"
        :key="index"
        class="field field--checkbox"
      >
        <span class="field__label">
          {{ formatLabel(priceRange) }}
        </span>
        <div class="input input--checkbox">
          <input
            :checked="priceRange.selected"
            type="checkbox"
            class="input__element input__element--checkbox"
            @change="toggleSelection(index)"
          />
          <span class="input__checkbox"></span>
        </div>
      </label>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PriceFilter",
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change"],
  data() {
    return {
      priceRanges: [
        { min: 0, max: 99.99, selected: false },
        { min: 100, max: 249.99, selected: false },
        { min: 250, max: 499.99, selected: false },
        { min: 500, max: null, selected: false },
      ],
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    parsedValues() {
      return this.values.length > 0
        ? JSON.parse(this.values[0].input).price
        : {};
    },
  },
  watch: {
    values: {
      handler: "setInitialSelections",
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.setInitialSelections();
  },
  methods: {
    formatLabel({ min, max }) {
      const minLabel = this.$filters.toCurrency(min, this.currencyCode, 0);
      const maxLabel =
        max !== null
          ? this.$filters.toCurrency(max, this.currencyCode, 0)
          : "+";
      return max !== null ? `${minLabel} - ${maxLabel}` : `${minLabel}+`;
    },
    getSelectedPriceRanges() {
      return this.priceRanges.filter(({ selected }) => selected);
    },
    calculateMinPrice(selectedPriceRanges) {
      return Math.min(...selectedPriceRanges.map(({ min }) => min));
    },
    calculateMaxPrice(selectedPriceRanges) {
      const maxPrices = selectedPriceRanges
        .map(({ max }) => max)
        .filter((max) => max !== null);
      return maxPrices.length ? Math.max(...maxPrices) : null;
    },
    emitPriceChange(min, max) {
      const price = max === null ? { min } : { min, max };
      this.$emit("change", { price });
    },
    setInitialSelections() {
      const { min, max } = this.parsedValues;
      this.priceRanges.forEach((priceRange) => {
        priceRange.selected =
          min <= priceRange.max && (max === null || max >= priceRange.min);
      });
    },
    toggleSelection(index) {
      this.priceRanges[index].selected = !this.priceRanges[index].selected;
      this.handlePriceRangeChange();
    },
    handlePriceRangeChange() {
      const selectedPriceRanges = this.getSelectedPriceRanges();
      if (!selectedPriceRanges.length) {
        this.emitPriceChange(null, null);
        return;
      }
      const min = this.calculateMinPrice(selectedPriceRanges);
      const max = this.calculateMaxPrice(selectedPriceRanges);
      this.emitPriceChange(min, max);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.price-filter {
  padding: 12px 0;
}
</style>
